import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Link,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import { gql } from 'graphql-request';
import { decentralandClient } from 'common/constants';

import { ReactComponent as PinIcon } from 'assets/images/svg/pin.svg';
import { Atlas } from 'decentraland-ui';

import { formatNumber } from 'common/utils';

import CloseIcon from '@mui/icons-material/Cancel';
import BidTable from './BidTable';
import OrderTable from './OrderTable';
import Mana from 'assets/images/png/mana.png';
import { useParcel } from 'providers/ParcelProvider';
import Transition from 'components/Transition';
import Loading from 'components/Loading';

const query = gql`
  query parcels($x: Int, $y: Int) {
    parcels(where: { x: $x, y: $y }) {
      id
      tokenId
      x
      y
      nft {
        contractAddress
        orders(orderBy: updatedAt, orderDirection: desc) {
          marketplaceAddress
          price
          status
          owner
          buyer
        }
        bids(orderBy: updatedAt, orderDirection: desc) {
          bidAddress
          price
          status
          seller
          expiresAt
        }
        activeOrder {
          marketplaceAddress
          price
        }
      }
    }
  }
`;

export default function ParcelDetail() {
  const classes = useStyles();

  const [parcel, setParcel] = useState(null);
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const { select, parcelOpen, setParcelOpen, tiles, price } = useParcel();

  useEffect(() => {
    async function fetchParcel() {
      try {
        setLoading(true);

        const data = await decentralandClient.request(query, {
          x: parseInt(select.x),
          y: parseInt(select.y),
        });

        console.log('data', data);
        setParcel(data.parcels[0]);
      } catch (error) {
        console.error(error);
        setParcel(null);
      } finally {
        setLoading(false);
      }
    }

    fetchParcel();
  }, [select]);

  const hoverStrokeLayer = (x, y) =>
    x === select.x && y === select.y ? { color: '#44ff00', scale: 1.5 } : null;

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Dialog
      open={parcelOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setParcelOpen(false)}
      classes={{ paper: classes.paper }}
    >
      {loading && (
        <div className={classes.loading}>
          <Loading />
        </div>
      )}

      {!parcel && (
        <h1 style={{ margin: 'auto' }}>
          Can't find parcel. Please try again later.
        </h1>
      )}

      {parcel && (
        <Grid container className={classes.container}>
          <Grid item xs={6}>
            <div style={{ height: '100%' }}>
              {tiles && (
                <Atlas
                  x={select.x}
                  y={select.y}
                  tiles={tiles}
                  layers={[hoverStrokeLayer]}
                />
              )}
            </div>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.content}>
              <div className={classes.top}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className={classes.pin}>
                    <PinIcon height="20" width="20" />
                    <Typography sx={{ marginLeft: '2px', color: '#0165FF' }}>
                      {`${select.x}, ${select.y}`}
                    </Typography>
                  </div>

                  <Typography sx={{ color: '#6F7172', marginRight: '24px' }}>
                    1 from Road
                  </Typography>

                  <Typography sx={{ color: '#0165FF' }}>
                    256m
                    <sup>2</sup>
                  </Typography>
                </div>

                <IconButton onClick={() => setParcelOpen(false)}>
                  <CloseIcon className={classes.close} />
                </IconButton>
              </div>

              <Typography
                variant="h4"
                sx={{
                  fontFamily: '"Montserrat"',
                  fontWeight: 'bold',
                  color: '#001A3C',
                }}
              >
                Parcel {`${select.x}, ${select.y}`}
              </Typography>

              <Typography
                sx={{
                  color: '#6F7172',
                  marginBottom: '24px',
                }}
              >
                Owned by
                <Link style={{ marginLeft: '8px' }} underline="none">
                  mjharris0129
                </Link>
              </Typography>

              <Grid container style={{ marginBottom: '24px' }}>
                <Grid item xs={6}>
                  <Typography sx={{ color: '#6F7172', marginBottom: '12px' }}>
                    Sale Price
                  </Typography>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Link
                      href="https://etherscan.io/address/0x0f5d2fb29fb7d3cfee444a200298f468908cc942"
                      target="_blank"
                      underline="none"
                      color="inherit"
                    >
                      <img style={{ height: 18 }} src={Mana} alt="Mana" />
                    </Link>

                    <Typography
                      sx={{
                        textAlign: 'right',
                        fontSize: 20,
                        fontWeight: 500,
                        marginLeft: '6px',
                      }}
                    >
                      {formatNumber(parcel?.nft?.activeOrder?.price, 0) || 0}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: 20,
                        marginLeft: '12px',
                        color: '#6F7172',
                      }}
                    >
                      ${formatNumber(parcel?.nft?.activeOrder?.price * price)}
                    </Typography>
                  </div>
                </Grid>

                {/* <Grid item xs={6}>
                  <Typography sx={{ color: '#6F7172', marginBottom: '12px' }}>
                    We-Estimate
                  </Typography>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Link
                      href="https://etherscan.io/address/0x0f5d2fb29fb7d3cfee444a200298f468908cc942"
                      target="_blank"
                      underline="none"
                      color="inherit"
                    >
                      <img style={{ height: 18 }} src={Mana} alt="Mana" />
                    </Link>

                    <Typography
                      sx={{
                        textAlign: 'right',
                        fontSize: 20,
                        fontWeight: 500,
                        marginLeft: '6px',
                      }}
                    >
                      {formatNumber(parcel?.nft?.activeOrder?.price, 0) || 0}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 500,
                        fontSize: 20,
                        marginLeft: '12px',
                        color: '#6F7172',
                      }}
                    >
                      ${formatNumber(parcel?.nft?.activeOrder?.price * price)}
                    </Typography>
                  </div>
                </Grid> */}
              </Grid>

              <div className={classes.info}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={tab} onChange={handleChange}>
                    <Tab
                      label="Overview"
                      sx={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                      }}
                    />
                    <Tab
                      label="Orders"
                      sx={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                      }}
                    />
                  </Tabs>
                </Box>

                <div hidden={tab !== 0}>
                  <Typography
                    textAlign="center"
                    sx={{
                      color: '#6F7172',
                      paddingTop: '12px',
                      marginBottom: '8px',
                    }}
                  >
                    This is a land in decentraland
                  </Typography>
                  <Typography
                    textAlign="center"
                    sx={{
                      color: '#6F7172',
                      marginBottom: '16px',
                    }}
                  >
                    Distance to Road: 1
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: '"Montserrat"',
                      fontWeight: 'bold',
                    }}
                  >
                    {'Bid & Offers'}
                  </Typography>

                  <BidTable data={parcel?.nft?.bids || []} />
                </div>

                <div hidden={tab !== 1}>
                  <OrderTable data={parcel?.nft?.orders || []} />
                </div>
              </div>

              <div className={classes.button}>
                <Link
                  href={`https://opensea.io/assets/${parcel?.nft?.contractAddress}/${parcel?.tokenId}`}
                  target="_blank"
                  underline="none"
                  color="inherit"
                  sx={{ flex: 2, marginRight: '24px' }}
                >
                  <Button
                    sx={{ width: '100%' }}
                    variant="contained"
                    color="primary"
                  >
                    <Typography sx={{ padding: '8px' }} variant="h5">
                      BUY NOW
                    </Typography>
                  </Button>
                </Link>
                <Button variant="outlined" sx={{ flex: 1 }}>
                  <Typography sx={{ padding: '8px' }} variant="h5">
                    VISIT
                  </Typography>
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '90vw',
    minHeight: '90vh',
    padding: '20px 24px',
  },
  paper: {
    minWidth: '90vw',
    minHeight: '90vh',
  },
  loading: {
    position: 'absolute',
    background: 'white',
    width: '100%',
    height: '100%',
    zIndex: 999,
  },
  content: {
    paddingLeft: 32,
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  top: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  pin: {
    border: '1px solid #0165FF',
    padding: '4px 8px',
    borderRadius: 4,
    marginRight: '24px',
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    '&:hover': {
      fill: 'red',
    },
  },
  info: {
    flex: 'auto',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
  },
}));
